import { UAParser } from 'ua-parser-js';

const parser = new UAParser();
const result = parser.getResult();

export function browser() {
  console.log(result);
  return result.browser.name;
}

export function browserVersion() {
  return result.browser.major;
}
